(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/mybets-core-wager/assets/javascripts/parsers/syndicate/syndicate.js') >= 0) return;  svs.modules.push('/components/numbergames/mybets-core-wager/assets/javascripts/parsers/syndicate/syndicate.js');

'use strict';

function mapSyndicateToWager(properties, syndicates) {
  if (properties && Array.isArray(syndicates)) {
    const syndicate = syndicates.find(syndicate => (syndicate === null || syndicate === void 0 ? void 0 : syndicate.syndicateId) === properties.syndicateId || parseInt(syndicate.id, 10) === properties.syndicateId);
    if (properties.syndicateId) {
      return parseSyndicate(properties, syndicate);
    }
  }
}

function parseSyndicate(properties) {
  var _syndicate$syndicateN;
  let syndicate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const members = syndicate.members || [];
  return {
    syndicateCurrentMember: members.find(member => member === null || member === void 0 ? void 0 : member.isCurrentMember),
    syndicateMembers: members,
    syndicateName: (_syndicate$syndicateN = syndicate.syndicateName) !== null && _syndicate$syndicateN !== void 0 ? _syndicate$syndicateN : syndicate.name,
    syndicateBettor: properties.syndicateBettor,
    syndicateParticipantCount: properties.syndicateParticipantCount,
    syndicateParticipatingMembers: properties.syndicateParticipatingMembers,
    syndicateId: properties.syndicateId,
    syndicateIsPermissionBlocked: syndicate.isPermissionBlocked
  };
}
if (svs.isServer) {
  module.exports = {
    mapSyndicateToWager,
    parseSyndicate
  };
} else {
  svs.numbergames.mybets_core_wager.parsers.syndicate = {
    mapSyndicateToWager,
    parseSyndicate
  };
}

 })(window);